export default __webpack_public_path__ + "static/media/about-icon.f4dfa411.png";